import { pollenBottleGetAllForDropdown } from "@/api/pollen_bottle";

const state = {
    pollenBottle: null,
    pollenBottleOptions: null,
    pollenBottleDetail: null
};

const mutations = {
    GET_ALL: (state, data) => {
        state.pollenBottle = data;
    },
    GET_ALL_OPTIONS: (state, data) => {
        state.pollenBottleOptions = data;
    },
    GET_DETAIL: (state, data) => {
        state.pollenBottleDetail = data;
    },
};

const actions = {
    async getAllPollenBottleOptions({ commit }) {
        let res = await pollenBottleGetAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/pollen_bottle.js